import React, { useEffect, useState, useRef } from "react"
import { WEGLOT_API_KEY } from "../../../constants/index"

const LanguageTranslator = (props) => {
  const { isMobileView } = props
  const [languages, setLanguages] = useState([])
  const [currentLang, setCurrentLang] = useState("en")
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!window.Weglot || window.Weglot.initialized) return

    window.Weglot.initialize({
      api_key: WEGLOT_API_KEY,
      // Next are optionals, often editable on your Weglot dashboard.
      // Options written here are concatenated with dashboard options when it's possible, otherwise these one have priority
      hide_switcher: true,
      // Automatically redirect visitor by its navigator's language
      auto_switch: true,
      // If auto switch is true, but you don't have visitor's language, redirect on this language code, otherwise original language
      auto_switch_fallback: "en",
      // Use front cache between pages, speed up your page loading!
      cache: true,
      // Hide original text before loading translated one, true by default
      wait_transition: true,
      excluded_paths: [
        {
          value: ["/conversations"],
          type: "CONTAIN" // IS_EXACTLY, CONTAIN, START_WITH, END_WITH, MATCH_REGEX
        }
      ],
    })

    window.Weglot.on("initialized", () => {
      const langs = [
        window.Weglot.options.language_from,
        ...window.Weglot.options.languages.map(l => l.language_to),
      ]

      setLanguages(langs)
      setCurrentLang(window.Weglot.getCurrentLang())
    })

    window.Weglot.on("languageChanged", (lang) => {
      setCurrentLang(lang)
      setIsOpen(false) // ✅ close on selection
    })
  }, [])

  // ✅ Close on outside tap (mobile UX)
  useEffect(() => {
    const handler = (e) => {
      if (!ref.current?.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("click", handler)
    return () => document.removeEventListener("click", handler)
  }, [])

  const toggle = () => setIsOpen(v => !v)

  const switchLang = (lang) => {
    if (lang === currentLang) return
    window.Weglot.switchTo(lang)
  }

  if (!languages.length) return null

  return (
    <div
      ref={ref}
      className={`language-switcher navbar-link is-arrowless ${
        isOpen ? "is-open" : ""} ${isMobileView ? 'mobile-view' : ''}`
      }
    >
      {/* 👇 Click works on mobile, hover still works on desktop */}
      <button
        type="button"
        className="lang-trigger"
        onClick={toggle}
        aria-expanded={isOpen}
      >
        <i className="fas fa-globe"></i>
      </button>

      <div className="lang-dropdown">
        {languages.map((lang) => (
          <button
            key={lang}
            className="weglot-link"
            onClick={() => switchLang(lang)}
            aria-current={lang === currentLang}
          >
            {window.Weglot.getLanguageName(lang)}
          </button>
        ))}
      </div>
    </div>
  )
}

export default LanguageTranslator
